type firebaseConfigurationType = {
    apiKey: string;
    authDomain: string;
    projectId: string;
    storageBucket: string;
    messagingSenderId: string;
    appId: string;
    measurementId: string;
};

export function getFirebaseConfiguration(): firebaseConfigurationType {
    try {
        // @ts-ignore
        return __FIREBAE_CONFIG__;
    } catch(_) {
        console.error("[ENV.TS] >> Can not find firebase configuration, loading default test...")
        return {
            apiKey: 'AIzaSyAO4Xp-k8ep-3Q8zvnJWdP3_wNcRFX0AZM',
            authDomain: 'beaver-weaver-social-1.firebaseapp.com',
            projectId: 'beaver-weaver-social-1',
            storageBucket: 'beaver-weaver-social-1.appspot.com',
            messagingSenderId: '901826750472',
            appId: '1:901826750472:web:6fd15f36895227d954c9bd',
            measurementId: 'G-4T9FMDJDFZ',
        };
    }
}
